import React from 'react';
import ImageGallery from 'react-image-gallery';

const GalleryRenderer = ({ comp }) => {
    const [aspectRatio, setAspectRatio] = React.useState(null);

    React.useEffect(() => {
        if (comp.type === 'gallery' && comp.images && comp.images.length > 0) {
            const firstImage = comp.images[0];
            const img = new Image();
            img.onload = () => {
                setAspectRatio(img.width / img.height);
            };
            img.src = firstImage.src;
        }
    }, [comp]);

    if (comp.type === 'gallery') {
        const images = (comp.images || []).map(img => ({
            original: img.src,
            thumbnail: img.src,
            description: img.title || ''
        }));

        return (
            <div style={{ width: '100%' }}>
                <style>{`
                    .image-gallery-fullscreen-button {
                        top: 0;
                        right: 0;
                        bottom: auto;
                    }
                    .image-gallery-fullscreen-button .image-gallery-svg {
                        height: 28px;
                        width: 28px;
                    }
                    ${aspectRatio ? `
                    .fixed-height-gallery .image-gallery-image {
                        aspect-ratio: ${aspectRatio};
                        height: auto;
                        object-fit: cover;
                    }
                    ` : ''}
                `}</style>
                <ImageGallery
                    items={images}
                    showNav={comp.showNav ?? false}
                    autoPlay={comp.autoPlay ?? true}
                    slideInterval={(comp.slideIntervalSeconds ?? 7) * 1000}
                    showFullscreenButton={comp.showFullScreenButton ?? true}
                    showPlayButton={false}
                    showThumbnails={comp.showThumbnails ?? false}
                    additionalClass="fixed-height-gallery"
                />
            </div>
        );
    }
    return null;
};

export default GalleryRenderer;
